import { useMemo } from 'react';

import { Link, Notification, NotificationProps } from '@bitrise/bitkit';

import useArchivedBuilds from '@/hooks/api/useArchivedBuilds';

export type ArchivedBuildsSectionProps = { appSlug: string } & Omit<NotificationProps, 'status'>;

const ArchivedBuildsSection = ({ appSlug, ...rest }: ArchivedBuildsSectionProps): JSX.Element | null => {
  const beforeTimestamp = useMemo(() => Math.floor(new Date().getTime() / 1000), []);
  const { archivedBuilds, isError } = useArchivedBuilds({
    appSlug,
    beforeTimestamp,
    afterTimestamp: 1,
    limit: 1,
  });

  if (!isError && (!archivedBuilds || archivedBuilds.length === 0)) {
    return null;
  }

  return (
    <Notification data-testid="archived-builds-list-notification" {...rest} status="info">
      Bitrise archives builds older than 200 days. These are available via the REST API. You can use our{' '}
      <Link
        isUnderlined
        isExternal
        href="https://devcenter.bitrise.io/en/builds/build-data-and-troubleshooting/build-logs.html#UUID-ef0d34e9-df1b-58fa-a19c-51a608ed9eec_UUID-da9c84ce-6975-309e-6406-e42293210fbe"
      >
        retrieval guide
      </Link>{' '}
      to easily fetch archived build logs and artifacts.
    </Notification>
  );
};

export default ArchivedBuildsSection;
